
  import { Vue, Component, Prop } from "vue-property-decorator";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
  import ActivityFormModal from "@/components/projects/activities/ActivityFormModalNew.vue";

  @Component({
    components: {
     UiButtonMessage,
      ActivityFormModal,
    },
  })
  export default class AddContractorToProject extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUser!: string;
    @Prop({ type: String, required: true }) readonly contractorId?: string;
    @Prop({ type: String, default: undefined }) readonly buttonSize?: string;
    @Prop({ type: String, default: undefined }) readonly variant?: string;
    @Prop({ type: Boolean, default: false }) readonly fullWidthTrigger!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withoutIcon!: boolean;

    modalShown: boolean = false;

    get isIconShown(): boolean {
      return this.variant !== "linkButton";
    }

    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }

    onActivityAdded(): void {
      this.$emit('activityAdded');
      this.closeModal();
    }
  }
